var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { staticClass: "vuestic-navbar navbar navbar-toggleable-md" },
    [
      _c(
        "div",
        {
          staticClass:
            "vuestic-navbar__logo navbar-brand-container align--center justify--start",
        },
        [
          _c(
            "router-link",
            { staticClass: "navbar-brand", attrs: { to: "/dashboard" } },
            [_vm._t("logo")],
            2
          ),
          _c("SelectMerchant"),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "va-row vuestic-navbar__content" },
        [
          _c(
            "div",
            {
              staticClass:
                "header-elem-wrapper menu-icon-container justify--start col",
            },
            [_vm._t("selector")],
            2
          ),
          _c(
            "div",
            {
              staticClass:
                "header-elem-wrapper navbar-text flex offset--md3 md5 d-none d-lg-flex",
            },
            [_vm._t("center")],
            2
          ),
          _vm._t("default"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }